// @flow
export const isPending = (state: Object): boolean => state.leaguesClassic.show_my.is_pending;

export const getError = (state: Object) => state.leaguesClassic.show_my.error;

export const getLeagues = (state: Object) =>
	state.leaguesClassic.show_my.ordered_ids.map(id => state.leaguesClassic.by_id[id]);